import React from "react";
import { useLocation } from "react-router-dom";
import "./Order_id_holder.css";
import Black_Btn from "../../../common_components/common_btn/black_btn/Black_Btn";
import Green_Btn from "../../../common_components/common_btn/green_btn/Green_Btn";
import Red_Outline_Btn from "../../../common_components/common_btn/red_outline_btn/Red_Outline_Btn";
// import Return_Lottie from "../../../Animation/return_Lottie/Return_Lottie";

function Order_id_holder({ order, date, headingText, subText }) {
  const location = useLocation();
  const isReturnPage = location.pathname === "/return-order-details";



  return (
    <>
      <section className="Order_id_holder">
        <div className="order_id">
          <div className="img_id_holder">
            {!isReturnPage && (
              <div>
                <div className="img_holder">
                  <img
                    className="Product_img"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/header/header_logo2.png"
                    }
                    alt="Product_img"
                  />
                </div>
              </div>
            )}

            {isReturnPage && (
              <div className="animation_holder">{/* <Return_Lottie /> */}</div>
            )}

            <div className="ms-3">
              <h2>{headingText}</h2>
              <p className="sub_text">{subText}</p>


              {!["Rejected", "Cancelled"].includes(subText) && (
                <Red_Outline_Btn
                  btn_name="Invoice"
                  order={order}
                />
              )}


            </div>
          </div>
          <p>{date}</p>
        </div>
      </section>
    </>
  );
}

export default Order_id_holder;
